import { useEffect, useState } from 'react'
import { IEquipment } from '@/pages/Equipment/equipment.types.ts'
import userApi from '@/pages/User/user.api.ts'
import CheckedIcon from '@/assets/icons/checked.svg?react'
import NotificationIcon from '@/assets/icons/notificationOutline.svg?react'
import useHttpLoader from '@/shared/hooks/useHttpLoader.ts'
import Button from '@/shared/Buttons/Button'
import css from './subscribeToNotificationsButton.module.css'
import Skeleton from '@/shared/Loaders/Skeleton'

interface IProps {
  equipmentId: IEquipment['id']
}

const SubscribeToNotificationsButton = (props: IProps) => {
  const { wait, loading } = useHttpLoader()
  const [isSubscribed, setIsSubscribed] = useState<boolean>(null)

  useEffect(() => {
    userApi.checkIfSubscribedForEquipmentEvents(props.equipmentId).then((r) => {
      if (r.status === 'success') {
        setIsSubscribed(r.body.subscribed)
      }
    })
  }, [props.equipmentId])

  const handleSubscribeToggle = (isSubscribed: boolean) => {
    if (loading) return

    const method = isSubscribed ? userApi.subscribeToEquipmentEventList : userApi.unsubscribeFromEquipmentEventList

    setIsSubscribed(isSubscribed)
    wait(method([props.equipmentId]))
  }

  if (isSubscribed === null) {
    return <Skeleton height={'32px'} width={'223px'} />
  }

  return (
    <div className={css.container}>
      <Button
        fullWidth={true}
        size="default"
        type={Boolean(isSubscribed) ? 'default' : 'primary'}
        onClick={() => handleSubscribeToggle(!isSubscribed)}
        text={Boolean(isSubscribed) ? 'Уведомления включены' : 'Включить уведомления'}
        loading={loading}
        icon={
          Boolean(isSubscribed) ? <CheckedIcon width={16} height={16} /> : <NotificationIcon width={16} height={16} />
        }
      />
    </div>
  )
}
export default SubscribeToNotificationsButton
